/**
 * Export Utility with Dynamic Imports
 * Lazily loads heavy libraries (XLSX, jsPDF) only when needed
 */

export const exportToExcel = async (data, fileName = 'export', columns = []) => {
    try {
        const XLSX = await import('xlsx');

        // Prepare data for export
        const exportData = data.map(row => {
            const obj = {};
            columns.forEach(col => {
                if (col.key !== 'actions') {
                    obj[col.label] = row[col.key];
                }
            });
            return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    } catch (error) {
        console.error('Excel Export Failed:', error);
        alert('Failed to export to Excel. Please try again.');
    }
};

export const exportToCSV = async (data, fileName = 'export', columns = []) => {
    try {
        const XLSX = await import('xlsx');

        const exportData = data.map(row => {
            const obj = {};
            columns.forEach(col => {
                if (col.key !== 'actions') {
                    obj[col.label] = row[col.key];
                }
            });
            return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${fileName}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error('CSV Export Failed:', error);
        alert('Failed to export to CSV.');
    }
};

export const exportToPDF = async (data, fileName = 'export', columns = []) => {
    try {
        const { jsPDF } = await import('jspdf');
        await import('jspdf-autotable');

        const doc = new jsPDF();

        const tableColumn = columns.filter(col => col.key !== 'actions').map(col => col.label);
        const tableRows = data.map(row => {
            return columns.filter(col => col.key !== 'actions').map(col => row[col.key]);
        });

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            theme: 'grid',
            headStyles: { fillColor: [67, 89, 113] } // Primary color
        });

        doc.text(fileName.toUpperCase(), 14, 15);
        doc.save(`${fileName}.pdf`);
    } catch (error) {
        console.error('PDF Export Failed:', error);
        alert('Failed to export to PDF.');
    }
};
